import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";


export const updateUserPaymentViewAction = (userPaymentDetailView: any): FluxStandardAction => {
    return {
        type: Actions.UPDATE_USER_PAYMENT_DETAIL_VIEW,
        payload: userPaymentDetailView        
    }
};
export const updateTotalValidOrdersAmount= (totalAmount: number): FluxStandardAction => {
    return {
        type: Actions.UPDATE_TOTAL_VALID_ORDERS_AMOUNT,
        payload: totalAmount        
    }
};
export const updateLoopBackUrl= (loopBackURL: string): FluxStandardAction => {
    return {
        type: Actions.UPDATE_LOOP_BACK_URL,
        payload: loopBackURL        
    }
};
